// @ts-nocheck

export const CARD_BADGE_WIDTH = 4;
export const CARD_BADGE_HEIGHT = 2.5;
export const CARD_BADGE_HEIGHT_BASKET = 2.1;
export const CARD_BADGE_WIDTH_BASKET = 3.2;
